<style lang="scss">
</style>

<template>
    <div>
        <div class="alert" :class="{'alert-success': (submitMessage.length > 0 && allCorrect), 'alert-danger': (submitMessage.length > 0 && !allCorrect)}" ref="submit-message" role="alert">
            {{ submitMessage }}
        </div>
        <form class="sirs-survey" ref="surveyForm" @submit.prevent="onClickSubmit">
            <!-- SHOW FORM FOR ASSESSMENT -->
            <template>
                <survey-modal
                    survey-type="build-the-skills-assessment"
                    :user="user"
                    fetch-view=true
                    :refresh-view="refreshView"
                ></survey-modal>
            </template>
        </form>
        <div class="alert" :class="{'alert-success': (submitMessage.length > 0 && allCorrect), 'alert-danger': (submitMessage.length > 0 && !allCorrect)}" ref="submit-message" role="alert">
            {{ submitMessage }}
        </div>
    </div>
</template>

<script>
    import SurveyModal from './SurveyModal';

	export default {
        components: {
            SurveyModal,
        },
        props: {
            user: {
                required: true,
                type: Object
            },
        },
        data() {
            return {
                submitMessage: "",
                allCorrect: false,
                refreshView: true,
            }
        },
        methods: {
            onClickSubmit() {
                // this.updateLoadStatus({isQuizLoading: true});
                let vm = this;
                let data = new FormData(this.$refs.surveyForm);
                data.append('nav', 'finalize');

                axios.post('build-the-skills/assessment/user/' + vm.user.id, data)
                .then(response => {
                    if(response.data.hasMaxScore === true) {
                        vm.allCorrect = true;
                        vm.submitMessage = "Congratulations! You have passed the Build the Skills assessment.";
                        vm.$emit('set-to-completed');
                    } else {
                        vm.submitMessage = response.data.correctCount + "/" + response.data.totalQuestions + " questions correct. You must answer 8 out of 10 questions correctly before proceeding. Please try again.";
                    }
                    this.refreshView = !this.refreshView; // toggle data to pull fresh view

                });
            },
            // getAssessmentContext() {
            //     let vm = this;
            //     axios.get('/build-the-skills/assessment/user/' + this.user.id + '/context')
            //         .then(response => {
            //             // vm.isAssessmentCompleted = !!response.data.context.response.finalized_at;
            //             if(!!response.data.context.response.finalized_at) {
            //                 vm.$emit('set-to-completed');
            //             }
            //         });
            // }
        },
        mounted() {
            // this.getAssessmentContext();
        }
    }
</script>